import { Skeleton } from "@/components/shadcn/skeleton";

export function GenieChatSkeleton() {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="flex flex-1 flex-col gap-4 px-7 pt-6">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
        <Skeleton className="ml-auto h-9 w-2/5 rounded-lg" />
        <div className="mt-4 flex flex-col gap-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-3/5" />
        </div>
        <Skeleton className="ml-auto h-9 w-1/3 rounded-lg" />
        <div className="mt-4 flex flex-col gap-2">
          <Skeleton className="h-4 w-11/12" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
      <div className="shrink-0 px-4 pb-3">
        <div className="flex flex-col rounded-xl border border-input bg-white shadow-xs">
          <div className="min-h-16 px-3 py-3">
            <Skeleton className="h-4 w-32 bg-muted" />
          </div>
          <div className="flex items-center justify-between px-3 pt-1.5 pb-3">
            <div className="flex items-center gap-1">
              <Skeleton className="size-6 bg-muted" />
              <Skeleton className="size-6 bg-muted" />
            </div>
            <Skeleton className="size-8 bg-muted" />
          </div>
        </div>
      </div>
    </div>
  );
}
